import React, { useLayoutEffect } from "react";
import { bool, string } from "prop-types";
import { classes } from "../utils/classes";

const WistiaVideoEmbed = ({
	id,
	shadow = false,
	className = "",
	videoFoam = true,
	autoPlay = false,
}) => {
	useLayoutEffect(() => {
		const script = document.createElement("script");
		script.src = `https://fast.wistia.com/embed/medias/${id}.jsonp`;
		script.async = true;
		document.body.appendChild(script);
		return () => {
			script.remove();
		};
	}, [id]);
	return (
		<div
			className={classes(
				"wistia_embed",
				`wistia_async_${id}`,
				"wistia-block-detail__embed",
				shadow && "wistia-block-detail--shadow",
				videoFoam ? "videoFoam=true" : "wistia_embed--foam-false",
				autoPlay && "autoplay=true",
				className,
			)}
		/>
	);
};

WistiaVideoEmbed.propTypes = {
	id: string.isRequired,
	shadow: bool,
	className: string,
	videoFoam: bool,
	autoPlay: bool,
};

export default WistiaVideoEmbed;
